import { DynamicRoute } from '@hawaiianair/core';

// add any dynamic routes your app may need here - variables in the URL segments,
// authentication or other guards, resolvers, canActivate, etc.
// always use the path property; do not  use children, loadChildren, or redirectTo.
export const dynamicRoutes: DynamicRoute[] = [];
